(function() {
    "use strict";

    angular.module("cardspotWeb.areas.hvtFulfillment")
        .controller("HvtFulfillment", HvtFulfillment);

    HvtFulfillment.$inject = ["$q", "$scope", "$rootScope", "notify", "hvtRequestService", "$translate", "moment", "ngDialog", 
        "authService", "CLAIMS", "LOOKUP_TYPES", "cardService", "preActivationService", "HVT_REQUEST_STATUS", "cardFees",
        "appConfig", "$timeout", "EVENT_NAMES", "customerService", "SF_EVENTS", "$uibModal", "receipts", "HVT_REQUEST_TYPES",
        "campaignService"];

    function HvtFulfillment($q, $scope, $rootScope, notify, hvtRequestService, $translate, moment, ngDialog, 
        authService, CLAIMS, LOOKUP_TYPES, cardService, preActivationService, HVT_REQUEST_STATUS, cardFees,
        appConfig, $timeout, EVENT_NAMES, customerService, SF_EVENTS, $uibModal, receipts, HVT_REQUEST_TYPES, 
        campaignService) {
            
        var model = this,
            fulfilled = 'Fulfilled';

        model.card = {
            printText: undefined,
            firstPrintText: null,
            firstPrimaryAccountNumber: null,
            lastPrintText: null,
            lastPrimaryAccountNumber: null,
            groupCardCount: null
        };

        model.sortKey = 'hvtRequestId';
        model.reverse = false;
        model.getApprovalQueue = getApprovalQueue;
        model.getApprovedHistory = getApprovedHistory;
        model.HVT_REQUEST_STATUS = HVT_REQUEST_STATUS;
		model.getOrderStatusDisplay = getOrderStatusDisplay;
        model.getModifiedDate = getModifiedDate;
		model.isInProgress = isInProgress;
        model.beginFulFillment = beginFulFillment;
		model.overRideFulfillmentAssociation = overRideFulfillmentAssociation;
		model.cancelOverride = cancelOverride;
        model.getCancelConfirmationMessage = getCancelConfirmationMessage;
        model.cancelOrder = cancelRequestConfirmModalPopup;
        model.cancelSale = cancelSale;
        model.sort = sort;
        model.showOrderInfo = showOrderInfo;
        model.approvalQueuePageChanged = approvalQueuePageChanged;
        model.approvalQueuePageSizeChanged = approvalQueuePageSizeChanged;
		model.setActiveCardGroup = setActiveCardGroup;
        model.canNavigateNext = canNavigateNext;
		model.canNavigatePrevious = canNavigatePrevious;
		model.setNextActiveCardGroup = setNextActiveCardGroup;
		model.setPreviousActiveCardGroup = setPreviousActiveCardGroup;
    	model.canViewRestrictedCardNumbers = authService.canViewRestrictedCardNumbers();
		model.canActivateWithoutSwipe = authService.hasClaim(CLAIMS.ACTIVATE_WITHOUT_SWIPE);
		model.maskPrintText = cardService.maskPrintText;
		model.resetGroupLookup = resetGroupLookup;
        model.PRE_ACTIVATION_TYPE = LOOKUP_TYPES;
		model.setPreActivationType = setPreActivationType;
        model.isPreActivationType = isPreActivationType;
        model.preActivateCardByPrintText = preActivateCardByPrintText;
		model.preActivateGroupCardByFirstPrintText = preActivateGroupCardByFirstPrintText;
		model.preActivateGroupCardByLastPrintText = preActivateGroupCardByLastPrintText;
		model.isValidForActivation = isValidForActivation;
        model.loading = false;
        model.cardPreActivationsComplete = cardPreActivationsComplete;
        model.CLAIMS = CLAIMS;
        model.getHvtFulfillmentHistory = getHvtFulfillmentHistory;
        model.historyPageSizeChanged = historyPageSizeChanged;
        model.doLookupHvtRequest = doLookupHvtRequest;
        model.isCancelled = isCancelled;
        model.historyPageChanged = historyPageChanged;
		model.historySortChanged = historySortChanged;
        model.getReceiptHtml = getReceiptHtml;
        model.hasPrinted = false;
        model.canPrint = canPrint;
        model.markAsPrinted = markAsPrinted;
        model.canFulfillOrder = canFulfillOrder;
        model.showNotePopover = false;
		model.clearCampaign = clearCampaign;
        model.canAddCampaigns = authService.canAddCampaigns() && !(appConfig.selectedMerchantGroup() && appConfig.selectedMerchantGroup().manageCampaigns);
        model.addNewCampaign = addNewCampaign;
        model.updateCampaign = updateCampaign;

		$scope.historyPageSize = 10;
		$scope.historySortKey = 'dateFulfilled';
		$scope.historySortAscending = false;
		$scope.historyCurrentPage = 1;
        $scope.forms = {};
        $scope.dateFormat = $scope.currentDateFormat();
        $scope.pageSizeOptions = [5, 10, 25, 50];

		var contactId = authService.currentContactId();

        $scope.dateFormat = $scope.currentDateFormat();

		model.pagination = {
			pageSize: $scope.pageSizeOptions[1]
		};

        var TAB_NAMES = {
			QUEUE: "queue",
			HISTORY: "history",
			DETAIL: "detail"
		};

        $scope.TAB_NAMES = TAB_NAMES;
        var activeTab = TAB_NAMES.QUEUE;

        var VIEW_NAMES = {
            FULFILLMENT: "fulfillment",
            SUMMARY: "summary",
            SALE_COMPLETE: "sale-complete"
        };
        model.VIEW_NAMES = VIEW_NAMES;
        var activeView = VIEW_NAMES.FULFILLMENT;

        model.viewVisible = function (viewName) {
            return viewName === activeView;
        };

        model.changeActiveView = function (view) {
            activeView = view;
        };

        $scope.tabClass = function (tabName) {
			var cssClass = "";
			if (tabName === activeTab) {
				cssClass = "active";
			}
			return cssClass;
		}

        $scope.tabVisible = function (tabName) {
			return tabName === activeTab;
		};

        model.queueSearch = {
            pageNumber: 1,
            pageSize: 10,
			filterText: null,
			approvalBeginDate: null,
			approvalEndDate: null
		};

        model.historySearch = {
            filterText: null,
            orderBeginDate: null,
            orderEndDate: null
        }

        var currentPreActivationType = model.PRE_ACTIVATION_TYPE.GROUP;

        init();

        function init() {
            getApprovalQueue();
        }

		$scope.$on(SF_EVENTS.CARDSWIPE_SUCCESS, handleCardSwipeSuccess);
        
        $rootScope.$on("hvtFulfillmentCancelled", function() {
            hvtRequestService.cancelHvtRequestFulfillment(model.currentHvtRequestId)
            .then((resp) => {
                if (resp.data.succeeded) {
                    getApprovalQueue();
                }
            })
        })

        $scope.saleCompleted = function () {
            $scope.$broadcast(EVENT_NAMES.SHOWING_HVT_SALE_COMPLETE, {});
            completeFulfillment(model.hvtOrder.id);
        };

        function formatSearchDate(dateToFormat) {
			return dateToFormat ? moment(dateToFormat).format("YYYY-MM-DD") : null;
		}

        function getApprovalQueue() {
            preActivationService.reset();
            activeTab = TAB_NAMES.QUEUE;
            model.currentHvtRequestId = null;
			let approvalBeginDate = formatSearchDate(model.queueSearch.approvalBeginDate);
			let approvalEndDate = formatSearchDate(model.queueSearch.approvalEndDate);
            notify.forHttp(hvtRequestService.getHvtApprovalQueue(
                model.queueSearch.pageNumber,
                model.queueSearch.pageSize,
                model.reverse,
                model.sortKey,
                model.queueSearch.filterText,
                approvalBeginDate,
                approvalEndDate
            ), { startTranslationId: "HVT.HVT_FULFILLMENT.PROGRESS_MESSAGES.GET_APPROVAL_QUEUE"})
            .then(data => {
                setHvtApprovalQueue(data);
            });
        }

        function setHvtApprovalQueue(data) {
            resetHvtFulfillment();
            var paged = data.approvedOrders;
            model.approvalQueue = Array.isArray(paged) ? paged : (paged && paged.items ? paged.items : []);
            model.approvalQueue.filteredItems = paged && paged.filteredItems ? paged.filteredItems : model.approvalQueue.length;
            model.approvalQueue.totalItems = paged && paged.totalItems ? paged.totalItems : model.approvalQueue.length;
        }

        function getApprovedHistory() {
            activeTab = TAB_NAMES.HISTORY;
            model.currentHvtRequestId = null;
            model.approvalHistory = true;
        }

        function getCancelConfirmationMessage() {
			return $translate.instant("HVT.HVT_FULFILLMENT.CANCEL_ORDER_CONFIRMATION_TEXT");
		}

        function beginFulFillment(hvtRequestId, modifyWhileInProgress = false) {
            model.currentHvtRequestId = hvtRequestId;
            model.loading = true;
            hvtRequestService.beginFulfillment(hvtRequestId, modifyWhileInProgress)
                .then(response => processStatusChangeRequest(response, hvtRequestId));
        }

        function processStatusChangeRequest(response, hvtRequestId) {
            if (!response.data.succeeded && response.data.statusContactId != contactId) {
                model.currentHvtRequestId = hvtRequestId;
                model.dialogMessage = response.data.message;
                checkForOverride();
                model.loading = false;
            } else {
                doLookupHvtRequest(hvtRequestId);
            }
        }

        function checkForOverride() {
			ngDialog.open({
				templateUrl: 'hvt-override-dialog-template.html',
				className: "ngdialog-theme-default",
				data: model
			});
		}

		function overRideFulfillmentAssociation() {
			ngDialog.close();
			beginFulFillment(model.currentHvtRequestId, true);
		}

		function cancelOverride() {
			ngDialog.close();
		}

        function doLookupHvtRequest(hvtRequestId) {
            notify.dismissErrorAlert();
            resetHvtFulfillment();
            activeTab = TAB_NAMES.DETAIL;

            if (!hvtRequestId) {
                nofity.showError("HVT.HVT_FULFILLMENT.ERROR_MESSAGES.INVALID_HVT_REQUEST_ID");
                return;
            }

            notify.forHttp(hvtRequestService.getHvtRequestDetails(hvtRequestId), 
            { startTranslationId: "HVT.HVT_FULFILLMENT.PROGRESS_MESSAGES.GET_HVT_REQUEST_DETAILS" })
                .then(response => setFulfillmentRequest(response.data, hvtRequestId));
        }

        function setFulfillmentRequest(data, hvtRequestId) {
            model.changeActiveView(model.VIEW_NAMES.FULFILLMENT);
            model.activationInProcess = false;
            model.hvtOrder = data;
            model.hvtOrder.id = hvtRequestId;
            model.hvtOrder.isFulfilled = model.hvtOrder.requestStatus === fulfilled;
            mapToCards(model.hvtOrder);
            
            model.hvtOrder.cardGroups = mapRequestCardGroups(model.hvtOrder);

            setActiveCardGroup(0);

            model.customer = mapCompanyAndPurchaserToCustomer(data.company, data.purchaser, data.hvtRequestType);

            data.payments.forEach(p => {
                p.paymentType.displayName = $translate.instant(`PAYMENT_TYPE.${p.paymentType.paymentTypeName}`);
            })

            model.payments = data.payments.map(function(payment) {
                var newPayment = angular.copy(payment);
                newPayment.isLocked = true;
                newPayment.paymentType.paymentType = payment.paymentType.paymentTypeName;
                return newPayment;
            });

            getFilteredCampaigns(data.programUniqueTag);

            model.loading = false;
        }

        function mapCompanyAndPurchaserToCustomer(company, purchaser, requestType) {
            let nameArray = purchaser.name.split(" ");
            let isCorporate = requestType.toLowerCase() === HVT_REQUEST_TYPES.CORPORATE;
            return {
                firstName: nameArray[0],
                middleName: null,
                lastName: nameArray[1],
                phoneNumber: purchaser.address.phone,
                phoneExt: purchaser.address.phoneExt,
                faxNumber: purchaser.address.fax,
                faxNumberExtension: purchaser.address.faxExt,
                emailAddress: purchaser.address.email,
                selectedCountry: isCorporate ? company.address.country : purchaser.address.country,
                address1: isCorporate ? company.address.address1 : purchaser.address.address1,
                address2: isCorporate ? company.address.address2 : purchaser.address.address2,
                city: isCorporate ? company.address.city : purchaser.address.city,
                selectedRegion: isCorporate ? company.address.stateOrProvince : purchaser.address.stateOrProvince,
                postalCode: isCorporate ? company.address.postalCode : purchaser.address.postalCode,
                companyName: isCorporate ? company.name : null,
                isOrganization: isCorporate ? true : false,
                marketingOptIn: false,
                identifier: null,
                companyRegistrationNumber: null,
                vat: null,
                birthDate: purchaser.birthDate,
                kycDocumentType: purchaser.identityDocumentType,
                kycDocumentId: purchaser.identityDocumentId,
                kycExpiryDate: purchaser.identityDocumentExpirationDate,
                requireCIP: true,
                customerType: isCorporate ? "Company" : "Individual"
            }
        }

        function mapToCards(hvtOrder) {
            let flattenedAmounts = [];
            hvtOrder.cardAmounts.forEach(function (amountGroup, key) {
                for(var i = 0; i < amountGroup.quantity; i++) {
                    flattenedAmounts.push({
                        cardId: amountGroup.cardId,
                        amount: amountGroup.amount,
                        cardAmountId: amountGroup.id,
                        primaryAccountNumber: null,
                        externalId: amountGroup.externalId,
                        isPreactivated: amountGroup.printText,
                        printTextDisplay: getPrintTextDisplay(amountGroup.printText),
                        index: i
                    })
                }
                amountGroup.index = key;
            })
            hvtOrder.flattenedAmounts = flattenedAmounts;
        }

        function mapRequestCardGroups(hvtOrder) {
            return hvtOrder.cardAmounts.reduce((cardGroups, item) => {
                var cardGroup = cardGroups.find(x => x.amount === item.amount);
                if (!cardGroup) {
                    let amounts = hvtOrder.cardAmounts.filter(x => x.amount === item.amount);
                    cardGroups.push({
                        amount: item.amount,
                        quantity: item.quantity,
                        hvtRequestCardAmountId: item.id,
                        amounts: amounts,
                        flattenedAmounts: hvtOrder.flattenedAmounts.filter(y => y.amount === item.amount),
                        isActive: false,
                        isPreactivated: false,
                        cardNumberDisplay: null,
                        preactivatedQuantity: 0
                    })
                } else {
                    cardGroup.quantity += item.quantity;
                }
                
                return cardGroups;
            }, [])
        }

        function getPrintTextDisplay(printText) {
			if (!printText) return null;
			return model.canViewRestrictedCardNumbers ? printText : cardService.maskPrintText(printText);
		}

        function setActiveCardGroup(index) {
            if (model.hvtOrder && model.hvtOrder.status === fulfilled) return;

            model.hvtOrder.cardGroups.map(x => x.isActive = false);

            // set next cardGroup to active
            let next = model.hvtOrder.cardGroups[index];
            if (next)
                next.index = index;
            else {
                //see if any other cardGroups need preactivation
                next = model.hvtOrder.cardGroups.find(x => x.isPreactivated === false);
            }

            // everything is preactivated
            if (!next) return;

            next.isActive = true;
            model.currentCardGroup = next;
            
			currentPreActivationType = model.currentCardGroup.quantity === 1 
				? model.PRE_ACTIVATION_TYPE.INDIVIDUAL 
				: model.PRE_ACTIVATION_TYPE.GROUP;
        }

        function setNextActiveCardGroup() {
            let activeCardGroup = getActiveCardGroup();
            return setActiveCardGroup(activeCardGroup.index + 1);
		}

		function setPreviousActiveCardGroup() {
            let activeCardGroup = getActiveCardGroup();
            return setActiveCardGroup(activeCardGroup.index - 1);
		}

        function resetHvtFulfillment() {
            model.hvtOrder = null;
            model.hvtFulfillmentHistory = null;
        }

        function cancelRequestConfirmModalPopup(hvtRequestId) {
            model.note = undefined;
			var cancelRequestConfirmModalInstance = $uibModal.open({
				templateUrl: "hvt/hvt-fulfillment/cancelHvtRequestDialog.html",
				backdrop: "static",
				keyboard: false,
				size: "sm",
				controller: "HvtCancelConfirmModal",
				scope: $scope
			})

			cancelRequestConfirmModalInstance.result
            .then(function (data) {
                if (data.isConfirmed === true)
				    cancelOrder(hvtRequestId, data.note);
			});
		}

        function cancelOrder(hvtRequestId, note) {
            notify.forHttp(hvtRequestService.cancelHvtRequest(
                hvtRequestId, note
            ), { startTranslationId: "HVT.HVT_FULFILLMENT.PROGRESS_MESSAGES.CANCEL_HVT_REQUEST", startTranslateValues: {hvtRequestId} })
            .then(resp => {
                if (resp.succeeded) {
                    getApprovalQueue();
                    notify.success("HVT.HVT_FULFILLMENT.PROGRESS_MESSAGES.CANCEL_HVT_REQUEST_SUCCESS", hvtRequestId, 1000);
                } else {
                    notify.showError("HVT.HVT_FULFILLMENT.PROGRESS_MESSAGES.CANCEL_HVT_REQUEST_ERROR", hvtRequestId, resp.message);
                }
            })
        }

        function cancelSale() {
            var cancelConfirmModalInstance = $uibModal.open({
                templateUrl: "hvt-sale-summary/modal/cancelConfirmDialog.html",
                backdrop: "static",
                keyboard: false,
                size: "sm",
                controller: "ConfirmModal",
                scope: $scope
            })

            cancelConfirmModalInstance.result.then(function (confirmed) {
                if (confirmed) {
                    currentPreActivationType = model.PRE_ACTIVATION_TYPE.GROUP;
                    $rootScope.$broadcast('hvtFulfillmentCancelled');
                }
            });
        }

        function sort(columnKey) {
			model.sortKey = columnKey;
			model.reverse = !model.reverse;
            getApprovalQueue();
		}

        function useOfCardsWithTranslateKey(o) {
            var otherArray;
            if (o.description.startsWith("Other"))
                otherArray = o.description.split(":");
            return {
                id: o.id,
                description: o.description,
                translateKey: !otherArray 
                    ? `USE_OF_CARD_OPTIONS.${o.description.replaceAll(" ", "")}` 
                    : `USE_OF_CARD_OPTIONS.${otherArray[0]}`,
                otherText: otherArray ? `: ${otherArray[1]}` : ""
            }
        }

        function purchaserWithDocumentTranslateKey(p) {
            return {
                ...p,
                identityDocumentTypeTranslateKey: p.identityDocumentType ? `DOCUMENT_TYPE.${p.identityDocumentType.replaceAll(" ", "")}` : null
            }
        }

        function showOrderInfo(hvtRequestId) {
            notify.forHttp(hvtRequestService.getHvtRequestDetails(hvtRequestId), 
                { startTranslationId: "HVT.HVT_FULFILLMENT.PROGRESS_MESSAGES.GET_HVT_REQUEST_DETAILS", startTranslateValues: {hvtRequestId} })
            .then(resp => {
                if (resp.succeeded) {
                    model.detail = resp.data;
                    model.detail.useOfCards = model.detail.useOfCards.map(useOfCardsWithTranslateKey); 
                    model.detail.purchaser = purchaserWithDocumentTranslateKey(model.detail.purchaser);
                    ngDialog.open({
                        templateUrl: 'hvt-request-details-dialog-template.html',
                        className: "ngdialog-theme-default",
                        data: model,
                        width: '50%',
                        closeByDocument: false,
                        closeByNavigation: true,
                        closeByEscape: true,
                        showClose: true
                    });
                }
            });
            return false;
        }

        function approvalQueuePageChanged(newPageNumber) {
            if (newPageNumber) {
                model.queueSearch.pageNumber = newPageNumber;
                getApprovalQueue();
            }
        }

        function approvalQueuePageSizeChanged() {
            model.queueSearch.pageNumber = 1;
            getApprovalQueue();
        }

        var currentPreActivationType = model.PRE_ACTIVATION_TYPE.GROUP;
		function setPreActivationType(type) {
			currentPreActivationType = type;
		}

		function isPreActivationType(type) {
			return type === currentPreActivationType;
		}

        function canNavigateNext() {
			if (!model.currentCardGroup) return false;

            return model.currentCardGroup.index +1 > model.hvtOrder.cardGroups.length -1;
		}

        function canNavigatePrevious() {
			if (!model.currentCardGroup) return false;
			return model.currentCardGroup.index - 1 < 0;
		}

        function resetGroupLookup() {
			model.card.firstPrintText = null;
			model.card.lastPrintText = null;
			model.card.firstPrimaryAccountNumber = null;
			model.card.lastPrimaryAccountNumber = null;
			model.card.groupCardCount = null;
			model.firstGroupCard = null;
			model.lastGroupCard = null;
			model.firstCardPreactivated = false;
			model.lastCardPreactivated = false;
			model.groupActivationLoading = false;
			$scope.forms.hvtPreActivateGroupCardForm.$setPristine();
			notify.dismissErrorAlert();
		}

        function isDuplicateCard(printText, primaryAccountNumber) {
			var isDupe = true;

			if (primaryAccountNumber) {
				isDupe = model.hvtOrder.flattenedAmounts.find(a => a.primaryAccountNumber === primaryAccountNumber.toString()) > -1;
			}
			if (printText) {
				isDupe = model.hvtOrder.flattenedAmounts.find(a => a.printText === printText.toString()) > -1;
			}
			return isDupe;
		}

        function resetLookup() {
			model.card.printText = null;
			$scope.forms.preActivateHvtCardForm.$setPristine();
			$scope.forms.preActivateHvtCardForm.cardNumber.$setPristine();
			notify.dismissErrorAlert();
		}

        function preActivateCardByPrintText() {
			notify.forFormSubmission($scope.forms.preActivateHvtCardForm, doPreactivateCard(model.card.printText));
		}

        function preActivateGroupCardByFirstPrintText() {
			notify.forFormSubmission($scope.forms.hvtPreActivateGroupCardForm, doPreactivateCard(model.card.firstPrintText));
		}

		function preActivateGroupCardByLastPrintText() {
			model.groupActivationLoading = true;
			notify.forFormSubmission($scope.forms.hvtPreActivateGroupCardForm, doPreactivateCard(model.card.lastPrintText));
		}

		function handleCardSwipeSuccess(event, swipe) {
			if (!model.currentCardGroup.isPreactivated)
				doPreactivateCard(null, swipe.primaryAccountNumber);
		}

        function doPreactivateCard(printText, primaryAccountNumber) {
			notify.dismissErrorAlert();

			// ensure not already added
			if (isDuplicateCard(printText, primaryAccountNumber)) {
				notify.showError("HVT.HVT_FULFILLMENT.VALIDATION_TEXT.CARD_ALREADY_ADDED");
				model.groupActivationLoading = false;
				return;
			};

			var preActivateCardPromise;
			if (printText) {
				preActivateCardPromise = preActivationService.preActivateByPrintText(printText, isPreActivationType(model.PRE_ACTIVATION_TYPE.GROUP));
			} else if (primaryAccountNumber) {
				preActivateCardPromise = preActivationService.preActivateBySwipe(primaryAccountNumber, isPreActivationType(model.PRE_ACTIVATION_TYPE.GROUP));
			} else {
				notify.showError("LOOKUP_CARD.FORM.INVALID_PRINT_TEXT_OR_SWIPE");
				model.groupActivationLoading = false;
				return;
			}

			notify.forHttp(preActivateCardPromise, { startTranslationId: "HVT.HVT_FULFILLMENT.PROGRESS_MESSAGES.PREACTIVATION_PROGRESS_TEXT" })
				.then(data => handlePreActivationResponse(data),() => {model.groupActivationLoading = false});
		}

        function handlePreActivationResponse(data) {
            let cardGroup = getActiveCardGroup();

            if (isPreActivationType(model.PRE_ACTIVATION_TYPE.INDIVIDUAL)) {
                let card = cardGroup.flattenedAmounts.find(x => x.amount === cardGroup.amount && !x.printText);
                card.printText = data.card.printText;
                card.primaryAccountNumber = data.card.primaryAccountNumber;
                card.cardId = data.card.cardId;
                card.isPreactivated = data.card.printText ? true : false;
                cardGroup.preactivatedQuantity = cardGroup.flattenedAmounts.reduce((qty, cardAmount) => {
					if (cardAmount.printText) {
						qty += 1;
					}
					return qty;
				}, 0);

                cardGroup.isPreactivated = cardGroup.flattenedAmounts.findIndex(x => !x.printText) === -1;
                cardGroup.isActive = !cardGroup.isPreactivated;
                cardGroup.cardNumberDisplay = getGroupCardNumberDisplay(cardGroup);
                
                updateModel(cardGroup);

                if (!cardGroup.isActive) {
                    setActiveCardGroup(cardGroup.index + 1);
                }

                resetLookup();
            } else {
                if (!model.firstCardPreactivated) {
					model.card.firstPrintText = Number(data.card.printText);
					model.card.firstPrimaryAccountNumber = data.card.primaryAccountNumber;
					model.firstCardPreactivated = true;
				} else if (!model.lastCardPreactivated) {
					model.card.lastPrintText = Number(data.card.printText);
					model.card.lastPrimaryAccountNumber = data.card.primaryAccountNumber;
					model.lastCardPreactivated = true;
					// now have the first and last preactivated,
					// so now need to do the preActivateGroup
					doPreActivateGroupCards(model.card.firstPrimaryAccountNumber, model.card.lastPrimaryAccountNumber);
				}
            }
        }

		function doPreActivateGroupCards(firstCardNumber, lastCardNumber) {
			notify.dismissErrorAlert();

			notify.forHttp(preActivationService.preActivateGroup(firstCardNumber, lastCardNumber), { startTranslationId: "LOOKUP_CARD.FORM.PROGRESS_TEXT" })
				.then(data => {
					handlePreActivationGroupResponse(data);
				})
				.catch(() => resetGroupLookup());
		}

        function handlePreActivationGroupResponse(data) {
            let cardGroup = getActiveCardGroup();

            let cards = cardGroup.flattenedAmounts.filter(x => x.amount === cardGroup.amount && !x.printText);

            if (cards.length < data.cards.length) {
                notify.showError("");
                resetGroupLookup();
                return;
            }

            data.cards.forEach(preActivatedCard => {
				let card = cardGroup.flattenedAmounts.find(x => x.amount === cardGroup.amount && !x.printText);
				if (card) {
					card.printText = preActivatedCard.printText;
					card.primaryAccountNumber = preActivatedCard.primaryAccountNumber;
					card.cardId = preActivatedCard.cardId;
                    card.isPreactivated = preActivatedCard.printText ? true : false;
                    preActivatedCard.amount = card.amount;
				}
			});

            cardGroup.preactivatedQuantity = cardGroup.flattenedAmounts.reduce((qty, cardAmount) => {
				if (cardAmount.printText) {
					qty += 1;
				}
				return qty;
			}, 0);

            cardGroup.isPreactivated = cardGroup.flattenedAmounts.findIndex(x => !x.printText) === -1;
			cardGroup.isActive = !cardGroup.isPreactivated;
			cardGroup.cardNumberDisplay = cardGroup.isPreactivated ? getGroupCardNumberDisplay(cardGroup) : null;
            
            updateModel(cardGroup);
            
			if (!cardGroup.isActive) {
                setActiveCardGroup(cardGroup.index + 1);
			}

			resetGroupLookup();
        }

        function setFixedFundingAmounts(activeCardGroup) {
			if (model.haveCards) {
                angular.forEach($scope.cardsPreActivated, function (group) {
                    if (!group.amount)
                        group.amount = angular.isArray(group.cards) && group.cards.length >= 1 ? group.cards[0].amount : activeCardGroup.amount;
                })
			}
		}

        function updateModel(activeCardGroup) {
			$scope.cardsPreActivated = preActivationService.getCardsPreActivated();
			model.haveCards = $scope.cardsPreActivated.length > 0;
			model.currencySymbol = model.haveCards ? $scope.cardsPreActivated[0].bin.currency.currencySymbol : "";
			model.cardTypes = preActivationService.getCardTypes();

            angular.forEach($scope.cardsPreActivated, function (cardPreActivated) {
                if (cardPreActivated.cards) {
                    angular.forEach(cardPreActivated.cards, function (card, index) {
                        if (activeCardGroup.amounts.length === 1) {
                            card.cardAmountId = !card.cardAmountId ? activeCardGroup.amounts[0].id : card.cardAmountId;
                        } else {
                            card.cardAmountId = !card.cardAmountId ? activeCardGroup.amounts[index].id : card.cardAmountId;
                        }
                    })
                } else {
                    cardPreActivated.cardAmountId = !cardPreActivated.cardAmountId 
                    ? activeCardGroup.amounts[0].id 
                    : cardPreActivated.cardAmountId;
                }
            })

            setFixedFundingAmounts(activeCardGroup);
            getFilteredCampaigns();
		}

        function updateCampaign(activeCardGroup, selectedCampaign) {
            $scope.cardsPreActivated = preActivationService.getCardsPreActivated();
            if (!$scope.cardsPreActivated || !$scope.cardsPreActivated.length) return;

            var flattened = (activeCardGroup && activeCardGroup.flattenedAmounts) || [];
            var hasFlattened = flattened && flattened.length > 0;

            // Build quick lookup: cardId -> desired index from flattenedAmounts
            var orderMap = {};
            if (hasFlattened) {
                for (var i = 0; i < flattened.length; i++) {
                orderMap[flattened[i].cardId] = i;
                }
            }

            // Try to match a group against flattenedAmounts
            var matchingGroup = findMatchingGroup($scope.cardsPreActivated, hasFlattened, flattened);

            if (matchingGroup && matchingGroup.cards && matchingGroup.cards.length) {
                // Align the order to flattenedAmounts
                alignCardsOrder(matchingGroup, hasFlattened, orderMap);

                // Update just the aligned subset first (in case there are extras)
                angular.forEach(matchingGroup.cards, function (card) {
                if (!hasFlattened || orderMap.hasOwnProperty(card.cardId)) {
                    card.campaign = selectedCampaign;
                }
                });
                return;
            }

            angular.forEach($scope.cardsPreActivated, function (cardPreActivated) {
                if (cardPreActivated.cards) {
                    angular.forEach(cardPreActivated.cards, function (card, index) {
                        card.campaign = selectedCampaign;
                    })
                } else {
                    if ($scope.cardsPreActivated.length > 1) {
                        var preActivatedCard = $scope.cardsPreActivated.find(x => x.printText === activeCardGroup.cardNumberDisplay);
                        if (preActivatedCard) {
                            preActivatedCard.campaign = selectedCampaign;
                        }
                    } else {
                        cardPreActivated.campaign = selectedCampaign;
                    }
                }
            })
        }

        function findMatchingGroup(cardsPreactivatedList, hasFlattened, flattened) {
            if (!hasFlattened) return null;

            // Strict pass: require all flattened ids to be present
            for (var g = 0; g < cardsPreactivatedList.length; g++) {
            var grp = cardsPreactivatedList[g];
            var cards = (grp && grp.cards) || [];
            if (!cards.length) continue;

            // Build set for this group's ids
            var groupIds = {};
            for (var c = 0; c < cards.length; c++) {
                groupIds[cards[c].cardId] = true;
            }

            var allPresent = true;
            for (var j = 0; j < flattened.length; j++) {
                if (!groupIds[flattened[j].cardId]) {
                allPresent = false;
                break;
                }
            }
            if (allPresent) return grp;
            }

            // Loose pass: match group containing first flattened id
            var firstId = flattened[0] ? flattened[0].cardId : null;
            if (firstId == null) return null;

            for (var g2 = 0; g2 < cardsPreactivatedList.length; g2++) {
            var grp2 = cardsPreactivatedList[g2];
            var cards2 = (grp2 && grp2.cards) || [];
            for (var c2 = 0; c2 < cards2.length; c2++) {
                if (cards2[c2].cardId === firstId) {
                return grp2;
                }
            }
            }

            return null;
        }

        function alignCardsOrder(preactivatedGroup, hasFlattened, orderMap) {
            if (!hasFlattened || !preactivatedGroup || !preactivatedGroup.cards || !preactivatedGroup.cards.length) {
            return;
            }

            var cards = preactivatedGroup.cards;
            var inOrder = [];
            var extras = [];

            for (var k = 0; k < cards.length; k++) {
            var card = cards[k];
            if (orderMap.hasOwnProperty(card.cardId)) {
                inOrder.push(card);
            } else {
                extras.push(card);
            }
            }

            // Sort the ones that are in the target set by the desired index
            inOrder.sort(function (a, b) {
            return orderMap[a.cardId] - orderMap[b.cardId];
            });

            preactivatedGroup.cards = inOrder.concat(extras);
        }

        function getGroupCardNumberDisplay(cardGroup) {
			if (!cardGroup.isPreactivated) return null;

			if (cardGroup.quantity > 1) {
				cardGroup.flattenedAmounts.sort(function (a, b) {
					if (a.printText < b.printText) {
						return -1;
					}
					if (a.printText > b.printText) {
						return 1;
					}
					// must be equal
					return 0;
				});
				let firstCard = cardGroup.flattenedAmounts[0];
				let lastCard = cardGroup.flattenedAmounts[cardGroup.flattenedAmounts.length - 1];

                let groupCardNumberDisplay = getPrintTextDisplay(firstCard.printText) + ' - ' + getPrintTextDisplay(lastCard.printText);
				return groupCardNumberDisplay;
			} else {
				let card = cardGroup.flattenedAmounts[0];

				return getPrintTextDisplay(card.printText);
			}
		}

        function isValidForActivation() {
            // all amounts in card amounts must be preactivated
            return model.hvtOrder?.cardGroups.findIndex(a => !a.isPreactivated) === -1;
		}

        function getActiveCardGroup() {
            return model.hvtOrder.cardGroups.find(a => a.isActive);
        }

        function getOrderStatusDisplay(status) {
			if (status === model.HVT_REQUEST_STATUS.FULFILLED) {
				return "HVT.HVT_FULFILLMENT.REQUEST_STATUS.FULFILLED";
			} else if (status === model.HVT_REQUEST_STATUS.IN_PROGRESS) {
				return "HVT.HVT_FULFILLMENT.REQUEST_STATUS.IN_PROGRESS";
			} else if (status === model.HVT_REQUEST_STATUS.CANCELLED) {
                return "HVT.HVT_FULFILLMENT.REQUEST_STATUS.CANCELLED";
            } else if (status === model.HVT_REQUEST_STATUS.APPROVED) {
                return "HVT.HVT_FULFILLMENT.REQUEST_STATUS.APPROVED"
            } else if (status === model.HVT_REQUEST_STATUS.FULFILLMENT_IN_PROGRESS) {
                return "HVT.HVT_FULFILLMENT.REQUEST_STATUS.FULFILLMENT_IN_PROGRESS";
            } else if (status === model.HVT_REQUEST_STATUS.DECLINED) {
                return "HVT.HVT_FULFILLMENT.REQUEST_STATUS.DECLINED";
            } else {
				return "HVT.HVT_FULFILLMENT.REQUEST_STATUS.CREATED";
			}
		}

        function getModifiedDate(order) {
			if (order.modifiedDateTime === "0001-01-01T00:00:00" || !isInProgress(order.requestStatus)) {
				return "";
			}
			return order.modifiedDateTime;
		}

        function isInProgress(status) {
			return status === model.HVT_REQUEST_STATUS.FULFILLMENT_IN_PROGRESS;
		}

        function cardPreActivationsComplete() {
            cardFees.getFees(
                appConfig.selectedMerchantGroup().uniqueTag, 
                preActivationService.getProgramUniqueTag(), 
                preActivationService.getCardsPreActivated())
            .then(function () {
                $timeout(function () {
                    $scope.$broadcast(EVENT_NAMES.SHOWING_HVT_SALE_SUMMARY, {});
                    model.changeActiveView(model.VIEW_NAMES.SUMMARY)
                })
            })
        }

        function completeFulfillment(hvtRequestId) {
            hvtRequestService.completeHvtRequestFulfillment(hvtRequestId)
            .then(function (response) {
                handleCompleteFulfillmentResponse(response, hvtRequestId);
            })
        }

        function handleCompleteFulfillmentResponse(response, hvtRequestId) {
            if (response.data.succeeded) {
                //switch to completed sale view
                model.hvtOrder.isFulfilled = true;
                model.changeActiveView(model.VIEW_NAMES.SALE_COMPLETE);
                model.doLookupHvtRequest(hvtRequestId);
                notify.success("HVT.HVT_FULFILLMENT.SUCCESS_MESSAGES.FULFILLMENT_SUCCEEDED", hvtRequestId, 1000)
            }
        }

        function getHvtFulfillmentHistory() {
            activeTab = TAB_NAMES.HISTORY;
            model.currentHvtRequestId = null;
            let historyBeginDate = formatSearchDate(model.historySearch.orderBeginDate);
            let historyEndDate = formatSearchDate(model.historySearch.orderEndDate);

            notify.forHttp(hvtRequestService.getHvtFulfillmentHistory(
                $scope.historyCurrentPage,
                $scope.historyPageSize,
                model.historySearch.filterText,
                historyBeginDate,
                historyEndDate
            ), {startTranslationId: "HVT.HVT_FULFILLMENT.PROGRESS_MESSAGES.GET_FULFILLMENT_HISTORY"})
            .then(data => {
                setHvtFulfillmentHistory(data);
            })
        }

        function setHvtFulfillmentHistory(data) {
            resetHvtFulfillment();
            model.hvtFulfillmentHistory = data.items;
            model.hvtFulfillmentHistory.filteredItems = data.filteredItems;
            model.hvtFulfillmentHistory.totalItems = data.totalItems;
        }

        function historyPageSizeChanged() {
			if (model.pagination.pageSize !== $scope.historyPageSize) {
				$scope.historyPageSize = model.pagination.pageSize;
				getHvtFulfillmentHistory();
			}
        }

        function historyPageChanged(newPageNumber) {
			if (newPageNumber) {
				$scope.historyCurrentPage = newPageNumber;
				getHvtFulfillmentHistory();
			}
		}

		function historySortChanged(sortKey) {
			if (sortKey) {
				$scope.historySortKey = sortKey;
				$scope.historySortAscending = !$scope.historySortAscending;
				getHvtFulfillmentHistory();
			}
		}

		function isCancelled(status) {
			return status === model.HVT_REQUEST_STATUS.CANCELLED || status === model.HVT_REQUEST_STATUS.DECLINED;
		}

        function canFulfillOrder(status) {
            var canFulfill = !model.loading && (status === model.HVT_REQUEST_STATUS.APPROVED || status === model.HVT_REQUEST_STATUS.FULFILLMENT_IN_PROGRESS);
            return canFulfill;
        }

        function canPrint() {
            if (!authService.isReprintDisabled()) {
                return true;
            }

            return !model.hasPrinted;
        }

        function markAsPrinted() {
            model.hasPrinted = true;
        }

        function getReceiptHtml() {
            var deferred = $q.defer();
            receipts.getReceipt(model.hvtOrder.cardAmounts[0].batchActivationSystemTransactionId, $translate.currentLanguage().key).then(function(receipt) {
                deferred.resolve(receipt.receiptHtml);
            }, function(error) {
                deferred.reject(error);
            });

            return deferred.promise;
        }

        function clearCampaign($event, $select) {
			$event.stopPropagation();
			$select.selected = undefined;
			$select.search = undefined;
		}

		function getActiveMerchantGroupCampaigns() {
			var deferred = $q.defer();
			campaignService.getAllMerchantGroupCampaigns()
				.then(function (response) {
					var campaigns = response.data;
					deferred.resolve(response.data);
					model.merchantGroupCampaigns = appConfig.selectedMerchantGroup() && appConfig.selectedMerchantGroup().manageCampaigns ? campaigns.filter(function (camp) {
						return camp.isActive === true;
					}) : [];
				}, function (error) {
					deferred.reject(error);
				});
			return deferred.promise;
		}

        function getFilteredCampaigns() {
			getActiveMerchantGroupCampaigns().then(function () {

				var campaigns = [];

				if (appConfig.selectedMerchantGroup() && appConfig.selectedMerchantGroup().manageCampaigns) {
					// if the property has campaign management enabled, get those campaigns
					var merchantGroupCampaigns = model.merchantGroupCampaigns.map(function (camp) {
						return camp["description"];
					});

					campaigns = campaigns.concat(merchantGroupCampaigns);
				} else {

					// Display program campaigns when manageCampaigns is turned off.
					var programCampaigns = preActivationService.getCampaigns();
					campaigns = campaigns.concat(programCampaigns);
				}
				// remove any duplicate campaign names
				model.campaigns = Array.from(new Set(campaigns));
			});
		}

        function addNewCampaign(cardGroup) {
			cardGroup.showAddCampaign = !cardGroup.showAddCampaign;
            if (cardGroup.campaign)
                updateCampaign(cardGroup, cardGroup.campaign);
		}
    }
}());